module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    directives: [{
      name: "infinite-scroll",
      rawName: "v-infinite-scroll",
      value: (_vm.loadData),
      expression: "loadData"
    }],
    staticStyle: {
      "display": "inline"
    },
    attrs: {
      "id": "contacts-index",
      "infinite-scroll-distance": "10"
    }
  }, [_c('div', {
    staticClass: "header-with-action"
  }, [_c('h1', {
    staticClass: "pull-left"
  }, [_vm._v(_vm._s(_vm.$t('businesses.title.index')))]), _c('button', {
    staticClass: "pull-right btn btn-primary",
    on: {
      "click": function($event) {
        return _vm.showCreateModal()
      }
    }
  }, [_c('span', {
    staticClass: "icon-more"
  }, [_vm._v("+")]), _vm._v(_vm._s(_vm.$t('businesses.actions.new')))])]), _c('div', {
    staticClass: "clear"
  }), (_vm.showNabBars()) ? _c('div', {
    staticClass: "row"
  }, [_c('ul', {
    staticClass: "tab-list",
    attrs: {
      "role": "tablist"
    }
  }, [_c('li', {
    attrs: {
      "role": "presentation"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.leadsRedirect()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('businesses.actions.contacts')))])]), _c('li', {
    attrs: {
      "role": "presentation"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.groupsRedirect()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('businesses.actions.groups')))])]), _c('li', {
    staticClass: "active",
    attrs: {
      "role": "presentation"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.businessRedirect()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('businesses.actions.companies')))])])])]) : _vm._e(), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-pane active",
    attrs: {
      "id": "groups-tab"
    }
  }, [_c('businesses-list', {
    attrs: {
      "businesses": _vm.businesses,
      "filters": _vm.filters
    },
    on: {
      "filter": _vm.filter
    }
  })], 1)]), _c('div', {
    attrs: {
      "align": "center"
    }
  }, [_c('loading', {
    attrs: {
      "loading": _vm.fetching
    }
  }), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.next_page),
      expression: "!next_page"
    }],
    staticClass: "light-gray-text light-text"
  }, [_vm._v(_vm._s(_vm.$t('businesses.feedback.noDataText')))])], 1), _c('new-business-modal', {
    on: {
      "business-create": _vm.created
    }
  }), _c('go-to-top')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2a473864!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/contacts/businesses.vue
// module id = 1053
// module chunks = 1